const MOTION_QUERY = '(prefers-reduced-motion: reduce)';

const prefersReducedMotion = () => window.matchMedia(MOTION_QUERY).matches;

const clearBioAnimationStyles = (bio) => {
	bio.style.maxHeight = '';
	bio.style.overflow = '';
};

const animateBioHeight = (bio, startHeight, endHeight, onComplete) => {
	if (prefersReducedMotion()) {
		clearBioAnimationStyles(bio);
		onComplete?.();
		return;
	}

	bio.style.overflow = 'hidden';
	bio.style.maxHeight = `${startHeight}px`;

	requestAnimationFrame(() => {
		bio.style.maxHeight = `${endHeight}px`;
	});

	const onTransitionEnd = (event) => {
		if (event.propertyName !== 'max-height') {
			return;
		}

		clearBioAnimationStyles(bio);
		bio.removeEventListener('transitionend', onTransitionEnd);
		onComplete?.();
	};

	bio.addEventListener('transitionend', onTransitionEnd);
};

const expandBio = (item, bio, toggle, label, onComplete) => {
	const startHeight = bio.clientHeight;

	bio.style.overflow = 'hidden';
	bio.style.maxHeight = `${startHeight}px`;
	item.classList.add('is-expanded');
	toggle.setAttribute('aria-expanded', 'true');
	label.textContent = 'Read less';

	animateBioHeight(bio, startHeight, bio.scrollHeight, onComplete);
};

const collapseBio = (item, bio, toggle, label, onComplete) => {
	const startHeight = bio.scrollHeight;

	bio.style.overflow = 'hidden';
	bio.style.maxHeight = `${startHeight}px`;
	item.classList.remove('is-expanded');
	toggle.setAttribute('aria-expanded', 'false');
	label.textContent = 'Read more';

	// Force clamped layout before measuring collapsed height.
	void bio.offsetHeight;

	animateBioHeight(bio, startHeight, bio.clientHeight, onComplete);
};

const initMeetTheTeam = (section) => {
	section.querySelectorAll('.meet-the-team__toggle').forEach((toggle) => {
		const item = toggle.closest('.meet-the-team__item');
		const bioId = toggle.getAttribute('aria-controls');
		const bio = bioId ? document.getElementById(bioId) : null;
		const label = toggle.querySelector('.meet-the-team__toggle-label');

		if (!item || !bio || !label) {
			return;
		}

		const syncToggleVisibility = () => {
			if (item.classList.contains('is-expanded')) {
				toggle.hidden = false;
				return;
			}

			clearBioAnimationStyles(bio);
			toggle.hidden = bio.scrollHeight <= bio.clientHeight + 1;
		};

		toggle.addEventListener('click', () => {
			if (item.classList.contains('is-expanded')) {
				collapseBio(item, bio, toggle, label, syncToggleVisibility);
				return;
			}

			expandBio(item, bio, toggle, label, syncToggleVisibility);
		});

		syncToggleVisibility();
		window.addEventListener('resize', syncToggleVisibility, { passive: true });
	});
};

const boot = () => {
	document.querySelectorAll('.meet-the-team').forEach((section) => {
		initMeetTheTeam(section);
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', boot);
} else {
	boot();
}
